/* ============================================================
   DM KONFIGURATOR — Sehstärken-Auswahl für Tauchmasken
   Diving Mask · Eigenentwicklung
   ------------------------------------------------------------
   Kein jQuery. Hängt sich additiv an das Symmetry-Kaufformular
   über das HTML5-Attribut form="<product_form_id>" — genau das
   Muster, das Symmetry für seine eigenen custom_option-Blöcke
   verwendet.
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Wertelisten ----------------------------------
     Die alte App bot eine unsortierte Liste mit Lücken an, in der
     Minuswerte fast vollständig fehlten. Hier wird der komplette
     Bereich in sauberen 0,25er-Schritten erzeugt.             */

  function reihe(von, bis, schritt) {
    var werte = [];
    var n = Math.round((von - bis) / schritt);
    for (var i = 0; i <= n; i++) {
      werte.push(+(von - i * schritt).toFixed(2));
    }
    return werte;
  }

  var SPHAERE = reihe(8, -12, 0.25);     // +8,00 bis −12,00
  var ZYLINDER = reihe(0, -6, 0.25);     //  0,00 bis  −6,00
  var ACHSE = (function () {
    var a = [];
    for (var i = 0; i <= 180; i += 1) a.push(i);
    return a;
  })();
  var PD_AUGE = (function () {
    var a = [];
    for (var v = 24; v <= 40; v += 0.5) a.push(Number(v.toFixed(1)));
    return a;
  })();

  var PD = (function () {
    var a = [];
    for (var i = 48; i <= 80; i += 1) a.push(i);
    return a;
  })();

  /* ---------- Formatierung ---------- */

  function dioptrie(n) {
    if (n === 0) return '0,00';
    var s = Math.abs(n).toFixed(2).replace('.', ',');
    return (n > 0 ? '+' : '−') + s;
  }

  /* ---------- Werkstatt-Format der alten App ----------------
     Der Inhaber liest die Sehwerte seit Jahren in genau dieser
     Schreibweise vom Auftrag ab. Deshalb wandern sie unveraendert
     als Line-Item-Properties in den Warenkorb:
       OD Right = -3.00 | -0.25 | x019
       OS Left  = -3.25 | -0.50 | x167
       PD       = OD - 32.00 | OS - 30.00
     ASCII-Vorzeichen, Punkt als Dezimaltrenner, Achse dreistellig
     mit fuehrenden Nullen. Nicht mit dioptrie() vermischen — das
     ist die deutsche Anzeige fuer den Kunden im Drawer.          */

  function altZahl(n) {
    var z = Number(n) || 0;
    if (z === 0) return '0.00';
    return (z > 0 ? '+' : '-') + Math.abs(z).toFixed(2);
  }

  function altAchse(n) {
    var a = Math.abs(parseInt(n, 10) || 0) % 360;
    return 'x' + ('00' + a).slice(-3);
  }

  /* Beträge kommen als Zahl in Shop-Währung (EUR) aus den
     Metaobjekten. Zeigt der Shop gerade eine andere Währung an
     (Shopify Markets setzt dann Shopify.currency.rate), muss der
     Aufpreis mitgerechnet werden — sonst stünde die Euro-Zahl mit
     fremdem Währungszeichen auf der Seite.
     Das Trennzeichen richtet sich nach dem Format des Shops:
     {{amount}} ist US-Stil, {{amount_with_comma_separator}} EU-Stil. */

  function kurs() {
    var sh = window.Shopify;
    if (sh && sh.currency && sh.currency.rate) {
      var k = parseFloat(sh.currency.rate);
      if (k > 0) return k;
    }
    return 1;
  }

  /* Formatiert einen bereits in Anzeigewaehrung vorliegenden Betrag.
     Wird fuer den Gesamtpreis im Drawer-Kopf gebraucht: der
     Variantenpreis kommt schon umgerechnet aus Liquid, nur die
     Aufpreise aus den Metaobjekten stehen in Shop-Waehrung. */
  function geldRoh(betrag, format) {
    var f = format || '{{amount}}';
    var kommaStil = f.indexOf('comma_separator') !== -1;
    var teile = betrag.toFixed(2).split('.');
    var ganz = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, kommaStil ? '.' : ',');
    var text = ganz + (kommaStil ? ',' : '.') + teile[1];

    if (f.indexOf('{{') !== -1) {
      return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, text);
    }
    return text + ' €';
  }

  function geld(betrag, format) {
    return geldRoh(betrag * kurs(), format);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function normalisiere(s) {
    return String(s || '').toLowerCase().trim().replace(/\s+/g, ' ');
  }

  function nachReihenfolge(a, b) {
    return (Number(a.reihenfolge) || 99) - (Number(b.reihenfolge) || 99);
  }

  /* ---------- Gruppen-Token ---------------------------------
     Verbindet Maske, Verglasung und Glasdicke im Warenkorb zu
     einer Einheit. Zeitanteil plus echter Zufall — Date.now()
     allein wäre bei zwei schnellen Abschlüssen nicht eindeutig. */

  function zufallsToken() {
    var zufall = '';
    try {
      if (window.crypto && window.crypto.getRandomValues) {
        var arr = new Uint32Array(2);
        window.crypto.getRandomValues(arr);
        zufall = arr[0].toString(36) + arr[1].toString(36);
      }
    } catch (e) { /* unten der Ersatz */ }
    if (!zufall) {
      zufall = Math.random().toString(36).slice(2) +
               Math.random().toString(36).slice(2);
    }
    /* Kurz gehalten: Der Wert steht in jeder Bestellung als _gruppe und
       soll nicht wie ein Datenbankschluessel aussehen. Sechs Zeichen aus
       Zufall reichen, um Zeilen innerhalb eines Warenkorbs zu verknuepfen. */
    return 'Set-' + zufall.slice(-6).toUpperCase();
  }

  /* Shopify stellt bei Sprachpräfixen (/en/…) die Wurzel unter
     Shopify.routes.root bereit. Ohne Angabe bleibt es bei "/". */
  function wurzelPfad() {
    var sh = window.Shopify;
    if (sh && sh.routes && sh.routes.root) return sh.routes.root;
    return '/';
  }

  /* ============================================================
     Das Element
     ============================================================ */

  class DmKonfigurator extends HTMLElement {

    connectedCallback() {
      var rohdaten = this.querySelector('.dm-k__data');
      if (!rohdaten) return;

      try {
        this.daten = JSON.parse(rohdaten.textContent);
      } catch (e) {
        console.warn('[dm-konfigurator] Datenpaket unlesbar:', e);
        return;
      }

      this.formId = this.dataset.formId;
      this.form = document.getElementById(this.formId);

      this.arten = (this.daten.verglasungsarten || []).slice().sort(nachReihenfolge);
      this.designs = (this.daten.glasdesigns || []).slice().sort(nachReihenfolge);
      this.dicken = (this.daten.glasdicken || []).slice().sort(nachReihenfolge);
      /* Zusatzleistungen (Fogbreaker, spaeter die dauerhafte
         Antibeschlag-Beschichtung). Rein additiv: fehlt die Liste,
         entfaellt der Schritt ersatzlos. */
      this.extras = (this.daten.extras || [])
        .filter(function (e) { return e.aktiv === true && e.varianteId; })
        .sort(nachReihenfolge);

      if (!this.arten.length) return;

      /* Welche Produktoption trägt die Verglasung? Die Optionsnamen
         sind im Katalog uneinheitlich (Lens Type, Leny Type, Lenses,
         Gläser …), deshalb wird über die Werte erkannt, nicht über
         den Namen. */
      this.verglasungsOption = this._findeVerglasungsOption();

      /* Der Basiswert der Verglasungs-Option, so wie ihn die
         Storefront ausliefert. Auf der deutschen Seite ist das
         nicht "None", sondern "Ohne Sehstärke" — deshalb kommt der
         Wert aus dem Datenpaket und wird nicht hart verglichen. */
      this.basisWert = normalisiere(this.daten.produkt.verglasungBasis || 'none');

      /* Produkte, die nur die Glaeser verkaufen ("Eigene Maske
         verglasen"): dort steckt der Verglasungspreis bereits im
         Variantenpreis. Es darf also keine zusaetzliche Verglasungs-
         position in den Warenkorb, sonst zahlt der Kunde doppelt.
         Glasdicke und Zusatzleistungen bleiben eigene Positionen. */
      this.glasImPreis = this.daten.produkt.glasImPreis === true;

      /* Dann sind nur die Verglasungen waehlbar, fuer die es an
         diesem Produkt auch wirklich eine Variante gibt. Fehlen sie
         alle, ist etwas falsch konfiguriert - dann bleibt es beim
         bisherigen Verhalten, statt gar nichts anzubieten. */
      if (this.glasImPreis) {
        var selbst = this;
        var mitVariante = this.arten.filter(function (a) {
          return !!selbst._varianteZuArt(a);
        });
        if (mitVariante.length) {
          this.arten = mitVariante;
        } else {
          this.glasImPreis = false;
        }
      }

      /* Sichtbare Texte kommen aus locales/*.json ueber das Datenpaket.
         Nicht uebersetzt werden die Feldnamen der Warenkorb-Positionen -
         die liest die Werkstatt. */
      this.t = this.daten.texte || {};

      this.auswahl = {
        art: null, design: null, dicke: null, extras: [],
        methode: 'eingabe',
        rechts: { sph: null, zyl: 0, ach: 0 },
        links: { sph: null, zyl: 0, ach: 0 },
        gleich: false,
        pd: null,
        pdEinzeln: false,
        pdR: null,
        pdL: null,
        name: ''
      };

      this.schrittIndex = 0;
      this.fertig = false;

      this._elemente();
      this._events();
      this._kaufButtonSperren(true);
    }

    /* ---------- DOM-Referenzen ---------- */

    _elemente() {
      var q = this.querySelector.bind(this);
      this.el = {
        trigger: q('[data-dm-open]'),
        summary: q('[data-dm-summary]'),
        hinweis: q('[data-dm-hinweis]'),
        felder: q('[data-dm-felder]'),
        overlay: q('[data-dm-overlay]'),
        drawer: q('[data-dm-drawer]'),
        body: q('[data-dm-body]'),
        titel: q('[data-dm-titel]'),
        zaehler: q('[data-dm-zaehler]'),
        bar: q('[data-dm-bar]'),
        zurueck: q('[data-dm-zurueck]'),
        weiter: q('[data-dm-weiter]'),
        preis: q('[data-dm-preis]'),
        preisWert: q('[data-dm-preis-wert]'),
        close: q('[data-dm-close]'),
        pVariante: q('[data-dm-p-variante]'),
        pGesamt: q('[data-dm-p-gesamt]')
      };
    }

    _events() {
      var self = this;

      this.el.trigger.addEventListener('click', function () { self.oeffnen(); });

      /* Grosser Kauf-Button der Produktseite: ersetzt bei aktivem
         Konfigurator die Warenkorb-Zeile und oeffnet den Drawer. */
      var start = this.form
        ? this.form.querySelector('[data-dm-start]')
        : document.querySelector('[data-dm-start]');
      if (start) start.addEventListener('click', function () { self.oeffnen(); });

      this.el.close.addEventListener('click', function () { self.schliessen(); });
      this.el.overlay.addEventListener('click', function () { self.schliessen(); });

      this.el.zurueck.addEventListener('click', function () { self.zurueck(); });
      this.el.weiter.addEventListener('click', function () { self.weiter(); });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !self.el.drawer.hidden) self.schliessen();
      });

      /* Symmetry meldet Variantenwechsel als natives, bubbelndes
         CustomEvent mit detail.variant — laut Theme-Quelltext
         ausdrücklich als Hook für Code außerhalb von jQuery gedacht. */
      document.addEventListener('change', function (e) {
        if (e.detail && e.detail.variant && self.form && self.form.contains(e.target)) {
          self._varianteGeaendert(e.detail.variant);
          self._produktkopf();
        }
      });

      /* Kaufversuch ohne Auswahl abfangen */
      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          if (!self.fertig) {
            e.preventDefault();
            e.stopPropagation();
            self._hinweisZeigen();
            self.oeffnen();
          }
        }, true);
      }
    }

    /* ---------- Verglasungs-Option erkennen ------------------
       Vergleicht die Optionswerte des Produkts mit den in den
       Metaobjekten hinterlegten Optionswerten. Die Option mit den
       meisten Treffern gewinnt. Damit ist der Konfigurator
       unabhängig davon, wie die Option am Produkt heißt.        */

    _findeVerglasungsOption() {
      /* Vorrang: die am Produkt hinterlegte Optionsposition
         (Metafeld dm_config.verglasung_pos). Sprachunabhängig,
         weil sie aus den unübersetzten Katalogdaten stammt. */
      var pos = Number(this.daten.produkt.verglasungPos || 0);
      if (pos > 0) {
        var fest = (this.daten.produkt.optionen || []).filter(function (o) {
          return Number(o.position) === pos;
        })[0];
        if (fest) return fest;
      }

      var bekannt = {};
      this.arten.forEach(function (a) {
        if (a.optionswert) bekannt[normalisiere(a.optionswert)] = true;
      });
      // Schreibweisen, die im Katalog zusätzlich vorkommen
      ['none', 'progressive - no line', 'bifocal / franklin',
       'single vision (just full shape possible)',
       'ohne sehstärke', 'ohne sehstaerke', 'einstärke', 'einstaerke',
       'gleitsicht', 'bifokal', 'bifokal (franklin)',
       'gleitsicht (ohne linie)'].forEach(function (w) {
        bekannt[w] = true;
      });

      var beste = null, besteTreffer = 0;
      (this.daten.produkt.optionen || []).forEach(function (opt) {
        var treffer = 0;
        (opt.werte || []).forEach(function (w) {
          if (bekannt[normalisiere(w)]) treffer++;
        });
        if (treffer > besteTreffer) { besteTreffer = treffer; beste = opt; }
      });

      return besteTreffer >= 2 ? beste : null;
    }

    /* Die Variante dieses Produkts, die zur gewaehlten Verglasung
       gehoert. Uebrige Optionen (Farbe) bleiben, soweit es sie gibt,
       auf dem aktuellen Stand. */
    _varianteZuArt(art) {
      if (!art) return null;

      /* Zuerst die am Produkt hinterlegte Zuordnung Verglasung ->
         Variante (Metafeld dm_config.glas_varianten). Sie besteht aus
         Handles und IDs und funktioniert deshalb in jeder Sprache.
         Der Vergleich ueber Optionswerte darunter greift nur, solange
         die Storefront die Werte nicht uebersetzt - auf der deutschen
         Seite heisst "Single Vision" eben "Einstaerke".              */
      var karte = this.daten.produkt.glasVarianten;
      if (karte && karte[art.handle]) {
        var gesucht = String(karte[art.handle]);
        var ausKarte = (this.daten.produkt.varianten || []).filter(function (v) {
          return String(v.id) === gesucht;
        })[0];
        if (ausKarte) return ausKarte;
      }

      if (!this.verglasungsOption) return null;
      var ziel = normalisiere(art.optionswert);
      var pos = this.verglasungsOption.position - 1;
      var passend = (this.daten.produkt.varianten || []).filter(function (v) {
        return normalisiere(v.optionen[pos]) === ziel;
      });
      if (!passend.length) return null;

      var aktuelle = this._aktuelleVariante();
      if (!aktuelle) return passend[0];
      var genau = passend.filter(function (v) {
        return v.optionen.every(function (o, i) {
          return i === pos || normalisiere(o) === normalisiere(aktuelle.optionen[i]);
        });
      })[0];
      return genau || passend[0];
    }

    /* Beim Glaeser-Produkt ist der Seitenpreis die guenstigste
       Verglasung. Alles Teurere wird als Aufschlag darauf gezeigt -
       Lars: "plus 340 sieht guenstiger aus als 580, ist im Ergebnis
       aber dasselbe." Der Gesamtpreis steht dabei jederzeit im Kopf
       des Schubfachs, es wird also nichts verschwiegen. */
    _glasBasisPreis() {
      if (this._glasBasis != null) return this._glasBasis;
      var kleinster = null, self = this;
      this.arten.forEach(function (a) {
        var v = self._varianteZuArt(a);
        if (v && (kleinster == null || v.preis < kleinster)) kleinster = v.preis;
      });
      this._glasBasis = kleinster == null ? 0 : kleinster;
      return this._glasBasis;
    }

    /* Aufschlag dieser Verglasung gegenueber der guenstigsten, in
       Anzeigewaehrung. Variantenpreise kommen bereits umgerechnet
       aus Liquid - hier darf kein Kurs mehr drauf. */
    _glasDifferenz(art) {
      var v = this._varianteZuArt(art);
      if (!v) return 0;
      var d = (v.preis - this._glasBasisPreis()) / 100;
      return d > 0 ? d : 0;
    }

    /* ---------- Schrittfolge ---------------------------------
       Wer „Ohne Sehstärke“ wählt, bekommt keine weiteren Schritte. */

    _schritte() {
      var s = ['art'];
      if (this.auswahl.art && Number(this.auswahl.art.aufpreis) >= 0 &&
          normalisiere(this.auswahl.art.optionswert) !== 'none') {
        if (this._passendeDesigns().length > 1) s.push('design');
        s.push('werte');
        if (this.dicken.length > 1) s.push('dicke');
        if (this.extras.length) s.push('extras');
        s.push('abschluss');
      }
      return s;
    }

    /* Laengstmoeglicher Weg: so viele Schritte kommen, wenn eine
       Verglasung mit Sehstaerke gewaehlt wird. Schaetzung fuer die
       Anzeige, nicht fuer die Steuerung. */
    _schritteMax() {
      var n = 2;                             /* Art + Werte */
      if (this.designs.length > 1) n++;
      if (this.dicken.length > 1) n++;
      if (this.extras.length) n++;
      n++;                                   /* Abschluss */
      return n;
    }

    _passendeDesigns() {
      var art = this.auswahl.art;
      if (!art) return this.designs;
      return this.designs.filter(function (d) {
        if (!d.passend_fuer || !d.passend_fuer.length) return true;
        return d.passend_fuer.some(function (p) {
          return normalisiere(p) === normalisiere(art.optionswert) ||
                 normalisiere(p) === normalisiere(art.titel);
        });
      });
    }

    /* ---------- Drawer öffnen / schließen ---------- */

    oeffnen() {
      this.el.overlay.hidden = false;
      this.el.drawer.hidden = false;
      document.documentElement.classList.add('dm-k-offen');
      this._platzFuerLeisten();
      this._render();
      var self = this;
      requestAnimationFrame(function () {
        self.el.drawer.classList.add('is-offen');
        self.el.overlay.classList.add('is-offen');
      });
    }

    /* ---------- Platz fuer fremde Leisten ------------------
       Shopifys Theme-Vorschau blendet unten eine Leiste ein, die
       als iframe ueber der ganzen Seite liegt und den Weiter-Button
       unerreichbar macht. Im veroeffentlichten Shop existiert sie
       nicht. Dasselbe gilt fuer Cookie-Banner am unteren Rand.      */

    _platzFuerLeisten() {
      var abstand = 0;

      var vorschau = document.getElementById('PBarNextFrame');
      if (vorschau && vorschau.parentElement) {
        var box = vorschau.parentElement.getBoundingClientRect();
        if (box.height > 0 && box.height < 200) abstand = box.height;
      }

      var banner = document.getElementById('shopify-pc__banner');
      if (banner) {
        var bb = banner.getBoundingClientRect();
        if (bb.height > 0 && bb.bottom >= window.innerHeight - 4) {
          abstand = Math.max(abstand, bb.height);
        }
      }

      this.el.drawer.style.bottom = abstand ? abstand + 'px' : '';
      this.el.overlay.style.bottom = abstand ? abstand + 'px' : '';
    }

    schliessen() {
      var self = this;
      this.el.drawer.classList.remove('is-offen');
      this.el.overlay.classList.remove('is-offen');
      document.documentElement.classList.remove('dm-k-offen');
      setTimeout(function () {
        self.el.drawer.hidden = true;
        self.el.overlay.hidden = true;
      }, 260);
    }

    zurueck() {
      if (this.schrittIndex > 0) { this.schrittIndex--; this._render(); }
    }

    weiter() {
      var schritte = this._schritte();
      if (this.schrittIndex < schritte.length - 1) {
        this.schrittIndex++;
        this._render();
      } else {
        this._abschliessen();
      }
    }

    /* ---------- Rendern ---------- */

    _render() {
      var schritte = this._schritte();
      if (this.schrittIndex >= schritte.length) this.schrittIndex = schritte.length - 1;

      var aktuell = schritte[this.schrittIndex];
      var titel = {
        art: this.t.t_art,
        design: this.t.t_design,
        werte: this.t.t_werte,
        dicke: this.t.t_dicke,
        extras: this.t.t_extras,
        abschluss: this.t.t_abschluss
      }[aktuell];

      this.el.titel.textContent = titel;
      /* Wie viele Schritte noch kommen, entscheidet sich erst mit der
         Verglasung. Vorher stuende hier "Schritt 1 von 1" und der
         Balken auf 100 % - deshalb bis dahin der laengste Weg. */
      var gesamt = this.auswahl.art ? schritte.length : this._schritteMax();
      if (gesamt < schritte.length) gesamt = schritte.length;

      this.el.zaehler.textContent = String(this.t.step || 'Schritt __N__ von __M__')
        .split('__N__').join(this.schrittIndex + 1)
        .split('__M__').join(gesamt);
      this.el.bar.style.width = ((this.schrittIndex + 1) / gesamt * 100) + '%';
      this.el.zurueck.hidden = this.schrittIndex === 0;

      /* Letzter Schritt legt direkt in den Warenkorb - kein Umweg
         zurueck zur Produktseite. Solange noch keine Verglasung
         gewaehlt ist, bleibt die neutrale Beschriftung. */
      var letzter = this.schrittIndex === schritte.length - 1;
      this.el.weiter.textContent =
        letzter && this.auswahl.art ? this.t.to_cart : this.t.next;

      this.el.body.innerHTML = this['_schritt_' + aktuell]();
      this.el.body.scrollTop = 0;
      this['_binde_' + aktuell] && this['_binde_' + aktuell]();

      this._preisAktualisieren();
      this._weiterPruefen();
    }

    /* ---------- Schritt: Verglasungsart ---------- */

    _schritt_art() {
      var gewaehlt = this.auswahl.art;
      var self = this;
      return '<div class="dm-k__karten">' + this.arten.map(function (a) {
        var aktiv = gewaehlt && gewaehlt.handle === a.handle;
        /* Beim Glaeser-Produkt ist der Betrag kein Aufpreis, sondern
           der Preis selbst - er kommt dann aus der Variante und wird
           ohne "+" gezeigt. */
        var preis = '';
        if (self.glasImPreis) {
          var mehr = self._glasDifferenz(a);
          preis = mehr > 0
            ? '<span class="dm-k__karte-preis">+ ' + esc(geldRoh(mehr, self.daten.geldformat)) + '</span>'
            : '<span class="dm-k__karte-preis dm-k__karte-preis--inkl">' + esc(self.t.included) + '</span>';
        } else if (Number(a.aufpreis) > 0) {
          preis = '<span class="dm-k__karte-preis">+ ' +
                  esc(geld(Number(a.aufpreis), self.daten.geldformat)) + '</span>';
        }
        return '' +
          '<button type="button" class="dm-k__karte' + (aktiv ? ' is-aktiv' : '') + '" data-art="' + esc(a.handle) + '">' +
            (a.bild ? '<img class="dm-k__karte-bild" src="' + esc(a.bild) + '" alt="" loading="lazy">' : '') +
            '<span class="dm-k__karte-text">' +
              '<span class="dm-k__karte-titel">' + esc(a.titel) + preis + '</span>' +
              (a.beschreibung ? '<span class="dm-k__karte-bes">' + esc(a.beschreibung) + '</span>' : '') +
            '</span>' +
          '</button>';
      }).join('') + '</div>' +
      (gewaehlt ? '<div class="dm-k__vorschau"><p class="dm-k__vorschau-h">' + esc(this.t.art_vorschau) + '</p>' + this._glasSkizze(gewaehlt) + '</div>' : '');
    }

    _binde_art() {
      var self = this;
      this.el.body.querySelectorAll('[data-art]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var h = btn.dataset.art;
          self.auswahl.art = self.arten.filter(function (a) { return a.handle === h; })[0];
          self.auswahl.design = null;
          self._render();
        });
      });
    }

    /* ---------- Vorschau der Verglasung ----------
       Liegt am Metaobjekt ein Bild, wird dieses gezeigt - so wie es
       Lars in der alten App kannte. Ohne hinterlegtes Bild zeichnet
       der Konfigurator die Skizze weiterhin selbst; damit bleibt die
       Vorschau auch dann vollstaendig, wenn zu einer Verglasungsart
       noch kein Bild gepflegt ist. */

    _glasSkizze(art) {
      if (art && art.bild_gross) {
        var bildtext = art.bild_alt || art.titel || '';
        return '' +
          '<figure class="dm-k__skizze dm-k__skizze--foto">' +
            '<img src="' + esc(art.bild_gross) + '" alt="' + esc(bildtext) + '" loading="lazy">' +
            '<figcaption>' + esc(art.titel || '') + '</figcaption>' +
          '</figure>';
      }

      var k = normalisiere(art && art.optionswert);
      var typ = 'none';
      if (k.indexOf('progressive') === 0 || k.indexOf('gleitsicht') === 0) typ = 'progressive';
      else if (k.indexOf('bifocal') === 0 || k.indexOf('bifokal') === 0) typ = 'bifocal';
      else if (k.indexOf('reader') === 0 || k.indexOf('lese') === 0 || k.indexOf('nah') === 0) typ = 'readers';
      else if (k.indexOf('single') === 0 || k.indexOf('einst') === 0 || k.indexOf('ferne') === 0) typ = 'single';

      var innen = {
        none:        '<rect x="10" y="10" width="140" height="88" rx="12" fill="url(#dmklar)"/>',
        single:      '<rect x="10" y="10" width="140" height="88" rx="12" fill="url(#dmfern)"/>',
        progressive: '<rect x="10" y="10" width="140" height="88" rx="12" fill="url(#dmverlauf)"/>',
        bifocal:     '<rect x="10" y="10" width="140" height="88" rx="12" fill="url(#dmfern)"/>' +
                     '<path d="M10 72 H150 V86 a12 12 0 0 1-12 12 H22 a12 12 0 0 1-12-12 Z" fill="url(#dmnah)"/>' +
                     '<path d="M10 72 H150" stroke="#0A2E43" stroke-width="2" opacity=".55"/>',
        readers:     '<rect x="10" y="10" width="140" height="88" rx="12" fill="url(#dmklar)"/>' +
                     '<path d="M46 74 a34 20 0 0 0 68 0 Z" fill="url(#dmnah)"/>' +
                     '<path d="M46 74 a34 20 0 0 0 68 0" fill="none" stroke="#0A2E43" stroke-width="2" opacity=".55"/>'
      }[typ];

      var text = this.t['sk_' + typ] || '';

      return '' +
        '<figure class="dm-k__skizze">' +
          '<svg viewBox="0 0 160 108" role="img" aria-hidden="true">' +
            '<defs>' +
              '<linearGradient id="dmverlauf" x1="0" y1="0" x2="0" y2="1">' +
                '<stop offset="0%" stop-color="#BBDDEB"/><stop offset="100%" stop-color="#7FB6D6"/>' +
              '</linearGradient>' +
              '<linearGradient id="dmfern" x1="0" y1="0" x2="0" y2="1">' +
                '<stop offset="0%" stop-color="#C9E4F0"/><stop offset="100%" stop-color="#BBDDEB"/>' +
              '</linearGradient>' +
              '<linearGradient id="dmnah" x1="0" y1="0" x2="0" y2="1">' +
                '<stop offset="0%" stop-color="#8FC0DC"/><stop offset="100%" stop-color="#6BA8CC"/>' +
              '</linearGradient>' +
              '<linearGradient id="dmklar" x1="0" y1="0" x2="0" y2="1">' +
                '<stop offset="0%" stop-color="#EDF5F9"/><stop offset="100%" stop-color="#DCEAF2"/>' +
              '</linearGradient>' +
            '</defs>' +
            innen +
            '<rect x="10" y="10" width="140" height="88" rx="12" fill="none" stroke="#0A2E43" stroke-width="3" opacity=".8"/>' +
            '<path d="M4 54 h6 M150 54 h6" stroke="#0A2E43" stroke-width="4" stroke-linecap="round" opacity=".8"/>' +
          '</svg>' +
          '<figcaption>' + esc(text) + '</figcaption>' +
        '</figure>';
    }

    /* ---------- Schritt: Glas-Design ---------- */

    _schritt_design() {
      var gewaehlt = this.auswahl.design;
      var self = this;
      return '<div class="dm-k__karten">' + this._passendeDesigns().map(function (d) {
        var aktiv = gewaehlt && gewaehlt.handle === d.handle;
        var preis = Number(d.aufpreis) > 0
          ? '<span class="dm-k__karte-preis">+ ' + esc(geld(Number(d.aufpreis), self.daten.geldformat)) + '</span>'
          : '';
        return '' +
          '<button type="button" class="dm-k__karte' + (aktiv ? ' is-aktiv' : '') + '" data-design="' + esc(d.handle) + '">' +
            (d.bild ? '<img class="dm-k__karte-bild" src="' + esc(d.bild) + '" alt="" loading="lazy">' : '') +
            '<span class="dm-k__karte-text">' +
              '<span class="dm-k__karte-titel">' + esc(d.titel) + preis + '</span>' +
              (d.beschreibung ? '<span class="dm-k__karte-bes">' + esc(d.beschreibung) + '</span>' : '') +
            '</span>' +
          '</button>';
      }).join('') + '</div>';
    }

    _binde_design() {
      var self = this;
      this.el.body.querySelectorAll('[data-design]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var h = btn.dataset.design;
          self.auswahl.design = self.designs.filter(function (d) { return d.handle === h; })[0];
          self._render();
        });
      });
    }

    /* ---------- Schritt: Sehwerte ---------- */

    _schritt_werte() {
      var a = this.auswahl;
      var t = this.t;
      var eingabe = a.methode === 'eingabe';

      var html = '' +
        '<div class="dm-k__methoden">' +
          '<button type="button" class="dm-k__methode' + (eingabe ? ' is-aktiv' : '') + '" data-methode="eingabe">' +
            '<span class="dm-k__methode-titel">' + esc(t.m_input_title) + '</span>' +
            '<span class="dm-k__methode-bes">' + esc(t.m_input_desc) + '</span>' +
          '</button>' +
          '<button type="button" class="dm-k__methode' + (a.methode === 'upload' ? ' is-aktiv' : '') + '" data-methode="upload">' +
            '<span class="dm-k__methode-titel">' + esc(t.m_upload_title) + '</span>' +
            '<span class="dm-k__methode-bes">' + esc(t.m_upload_desc) + '</span>' +
          '</button>' +
          '<button type="button" class="dm-k__methode' + (a.methode === 'spaeter' ? ' is-aktiv' : '') + '" data-methode="spaeter">' +
            '<span class="dm-k__methode-titel">' + esc(t.m_later_title) + '</span>' +
            '<span class="dm-k__methode-bes">' + esc(t.m_later_desc) + '</span>' +
          '</button>' +
        '</div>';

      if (a.methode === 'spaeter') {
        return html + '<p class="dm-k__notiz dm-k__notiz--kasten">' + esc(t.later_note) + '</p>';
      }

      if (a.methode === 'upload') {
        html += '' +
          '<div class="dm-k__upload">' +
            '<label class="dm-k__upload-feld">' +
              '<input type="file" accept="image/*,.pdf" data-dm-datei>' +
              '<span class="dm-k__upload-text">' + esc(t.upload_cta) + '</span>' +
            '</label>' +
            '<p class="dm-k__notiz">' + esc(t.values_note) + '</p>' +
          '</div>';
        return html;
      }

      html += '' +
        '<label class="dm-k__checkbox">' +
          '<input type="checkbox" data-dm-gleich' + (a.gleich ? ' checked' : '') + '>' +
          '<span>' + esc(t.same_eyes) + '</span>' +
        '</label>' +
        '<div class="dm-k__augen">' +
          this._auge('rechts', t.eye_right, 'R') +
          (a.gleich ? '' : this._auge('links', t.eye_left, 'L')) +
        '</div>' +
        '<div class="dm-k__pd">' +
          '<label class="dm-k__label" for="dm-pd">' + esc(t.pd) + ' <span class="dm-k__optional">' + esc(t.optional) + '</span></label>' +
          (a.pdEinzeln
            ? '<div class="dm-k__pd-paar">' +
                '<div><label class="dm-k__label dm-k__label--klein" for="dm-pd-r">' + esc(t.pd_right) + '</label>' +
                  this._select('dm-pd-r', 'pdR', PD_AUGE, a.pdR, function (v) { return v + ' mm'; }, t.unknown) + '</div>' +
                '<div><label class="dm-k__label dm-k__label--klein" for="dm-pd-l">' + esc(t.pd_left) + '</label>' +
                  this._select('dm-pd-l', 'pdL', PD_AUGE, a.pdL, function (v) { return v + ' mm'; }, t.unknown) + '</div>' +
              '</div>'
            : this._select('dm-pd', 'pd', PD, a.pd, function (v) { return v + ' mm'; }, t.unknown)) +
          '<label class="dm-k__checkbox dm-k__checkbox--klein">' +
            '<input type="checkbox" data-dm-pd-einzeln' + (a.pdEinzeln ? ' checked' : '') + '>' +
            '<span>' + esc(t.pd_single) + '</span>' +
          '</label>' +
          '<p class="dm-k__notiz">' + esc(t.pd_note) + '</p>' +
        '</div>';

      return html;
    }

    _auge(seite, beschriftung, kuerzel) {
      var w = this.auswahl[seite];
      var t = this.t;
      return '' +
        '<div class="dm-k__auge">' +
          '<p class="dm-k__auge-titel"><span class="dm-k__auge-kuerzel">' + kuerzel + '</span>' + beschriftung + '</p>' +
          '<div class="dm-k__auge-felder">' +
            '<div>' +
              '<label class="dm-k__label" for="dm-' + seite + '-sph">' + esc(t.sph) + '</label>' +
              this._select('dm-' + seite + '-sph', seite + '.sph', SPHAERE, w.sph, dioptrie, t.choose) +
            '</div>' +
            '<div>' +
              '<label class="dm-k__label" for="dm-' + seite + '-zyl">' + esc(t.cyl) + '</label>' +
              this._select('dm-' + seite + '-zyl', seite + '.zyl', ZYLINDER, w.zyl, dioptrie, null) +
            '</div>' +
            '<div>' +
              '<label class="dm-k__label" for="dm-' + seite + '-ach">' + esc(t.axis) + '</label>' +
              this._select('dm-' + seite + '-ach', seite + '.ach', ACHSE, w.ach, function (v) { return v + '°'; }, null) +
            '</div>' +
          '</div>' +
        '</div>';
    }

    _select(id, pfad, werte, gewaehlt, format, leerText) {
      var opt = leerText
        ? '<option value=""' + (gewaehlt == null ? ' selected' : '') + '>' + esc(leerText) + '</option>'
        : '';
      opt += werte.map(function (v) {
        var sel = (gewaehlt != null && Number(gewaehlt) === Number(v)) ? ' selected' : '';
        return '<option value="' + v + '"' + sel + '>' + esc(format(v)) + '</option>';
      }).join('');
      return '<select class="dm-k__select" id="' + id + '" data-pfad="' + pfad + '">' + opt + '</select>';
    }

    _binde_werte() {
      var self = this;

      this.el.body.querySelectorAll('[data-methode]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.auswahl.methode = btn.dataset.methode;
          self._render();
        });
      });

      var pdE = this.el.body.querySelector('[data-dm-pd-einzeln]');
      if (pdE) {
        pdE.addEventListener('change', function () {
          self.auswahl.pdEinzeln = pdE.checked;
          /* Umrechnen statt verwerfen: aus der Gesamt-PD werden zwei
             gleiche Haelften, aus zwei Einzelwerten wieder die Summe. */
          if (pdE.checked) {
            if (self.auswahl.pd && !self.auswahl.pdR && !self.auswahl.pdL) {
              var h = Math.round(self.auswahl.pd) / 2;
              self.auswahl.pdR = Math.round(h * 2) / 2;
              self.auswahl.pdL = self.auswahl.pdR;
            }
          } else if (self.auswahl.pdR && self.auswahl.pdL && !self.auswahl.pd) {
            self.auswahl.pd = Math.round(self.auswahl.pdR + self.auswahl.pdL);
          }
          self._render();
        });
      }

      var gleich = this.el.body.querySelector('[data-dm-gleich]');
      if (gleich) {
        gleich.addEventListener('change', function () {
          self.auswahl.gleich = gleich.checked;
          if (gleich.checked) {
            self.auswahl.links = Object.assign({}, self.auswahl.rechts);
          }
          self._render();
        });
      }

      this.el.body.querySelectorAll('[data-pfad]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var teile = sel.dataset.pfad.split('.');
          var wert = sel.value === '' ? null : Number(sel.value);
          if (teile.length === 2) {
            self.auswahl[teile[0]][teile[1]] = wert;
            if (self.auswahl.gleich && teile[0] === 'rechts') {
              self.auswahl.links = Object.assign({}, self.auswahl.rechts);
            }
          } else {
            self.auswahl[teile[0]] = wert;
          }
          self._weiterPruefen();
          self._dickeEmpfehlen();
        });
      });

      var datei = this.el.body.querySelector('[data-dm-datei]');
      if (datei) {
        datei.addEventListener('change', function () {
          self.auswahl.datei = datei.files && datei.files[0] ? datei.files[0].name : null;
          self._dateiFeld(datei.files && datei.files[0]);
          self._weiterPruefen();
        });
      }
    }

    /* ---------- Schritt: Glasdicke ---------- */

    _schritt_dicke() {
      var self = this;
      var gewaehlt = this.auswahl.dicke;
      var maxSph = this._maxSphaere();

      return '<div class="dm-k__karten">' + this.dicken.map(function (d) {
        var aktiv = gewaehlt && gewaehlt.handle === d.handle;
        var empfohlen = maxSph != null && Number(d.empfohlen_ab) > 0 &&
                        maxSph >= Number(d.empfohlen_ab) &&
                        !self.dicken.some(function (x) {
                          return Number(x.empfohlen_ab) > Number(d.empfohlen_ab) &&
                                 maxSph >= Number(x.empfohlen_ab);
                        });
        var preis = Number(d.aufpreis) > 0
          ? '<span class="dm-k__karte-preis">+ ' + esc(geld(Number(d.aufpreis), self.daten.geldformat)) + '</span>'
          : '<span class="dm-k__karte-preis dm-k__karte-preis--inkl">' + esc(self.t.included) + '</span>';
        return '' +
          '<button type="button" class="dm-k__karte' + (aktiv ? ' is-aktiv' : '') + '" data-dicke="' + esc(d.handle) + '">' +
            '<span class="dm-k__karte-text">' +
              '<span class="dm-k__karte-titel">' + esc(d.titel) + preis + '</span>' +
              (d.beschreibung ? '<span class="dm-k__karte-bes">' + esc(d.beschreibung) + '</span>' : '') +
              (empfohlen ? '<span class="dm-k__empfehlung">' + esc(self.t.recommended) + '</span>' : '') +
            '</span>' +
          '</button>';
      }).join('') + '</div>';
    }

    _binde_dicke() {
      var self = this;
      this.el.body.querySelectorAll('[data-dicke]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var h = btn.dataset.dicke;
          self.auswahl.dicke = self.dicken.filter(function (d) { return d.handle === h; })[0];
          self._render();
        });
      });
    }

    _maxSphaere() {
      var a = this.auswahl;
      var werte = [a.rechts.sph, a.links.sph].filter(function (v) { return v != null; });
      if (!werte.length) return null;
      return Math.max.apply(null, werte.map(Math.abs));
    }

    _dickeEmpfehlen() {
      if (this.auswahl.dicke) return;
      var maxSph = this._maxSphaere();
      if (maxSph == null) return;
      var passend = this.dicken.filter(function (d) {
        return maxSph >= Number(d.empfohlen_ab || 0);
      });
      if (passend.length) this.auswahl.dicke = passend[passend.length - 1];
    }

    /* ---------- Schritt: Zusatzleistungen ----------
       Mehrfachauswahl, keine Pflicht. Jede gewaehlte Leistung wird
       zu einer eigenen Warenkorb-Zeile, wie Verglasung und Dicke. */

    _schritt_extras() {
      var self = this;
      return '' +
        '<p class="dm-k__hinweis-text">' + esc(self.t.extras_optional) + '</p>' +
        '<div class="dm-k__karten">' + this.extras.map(function (e) {
          var aktiv = self._extraGewaehlt(e.handle);
          return '' +
            '<button type="button" class="dm-k__karte dm-k__karte--mehrfach' + (aktiv ? ' is-aktiv' : '') + '" data-extra="' + esc(e.handle) + '" aria-pressed="' + (aktiv ? 'true' : 'false') + '">' +
              '<span class="dm-k__haken" aria-hidden="true">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="m5 13 4 4L19 7"/></svg>' +
              '</span>' +
              '<span class="dm-k__karte-text">' +
                '<span class="dm-k__karte-titel">' + esc(e.titel) +
                  '<span class="dm-k__karte-preis">+ ' + esc(geld(Number(e.aufpreis) || 0, self.daten.geldformat)) + '</span>' +
                '</span>' +
                (e.beschreibung ? '<span class="dm-k__karte-bes">' + esc(e.beschreibung) + '</span>' : '') +
              '</span>' +
            '</button>';
        }).join('') + '</div>';
    }

    _binde_extras() {
      var self = this;
      this.el.body.querySelectorAll('[data-extra]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self._extraUmschalten(btn.dataset.extra);
          self._render();
        });
      });
    }

    _extraGewaehlt(handle) {
      return this.auswahl.extras.some(function (e) { return e.handle === handle; });
    }

    _extraUmschalten(handle) {
      var liste = this.auswahl.extras;
      var idx = -1;
      liste.forEach(function (e, i) { if (e.handle === handle) idx = i; });
      if (idx >= 0) { liste.splice(idx, 1); return; }
      var eintrag = this.extras.filter(function (e) { return e.handle === handle; })[0];
      if (eintrag) liste.push(eintrag);
    }

    _extraSumme() {
      return this.auswahl.extras.reduce(function (s, e) {
        return s + (Number(e.aufpreis) || 0);
      }, 0);
    }

    /* ---------- Schritt: Abschluss ---------- */

    _schritt_abschluss() {
      var a = this.auswahl;
      var zeilen = [];

      zeilen.push([this.t.s_glazing, a.art ? a.art.titel : '—']);
      if (a.design) zeilen.push([this.t.s_design, a.design.titel]);
      if (a.dicke) zeilen.push([this.t.s_thickness, a.dicke.titel]);
      var self = this;
      a.extras.forEach(function (e) { zeilen.push([self.t.s_extra, e.titel]); });

      if (a.methode === 'spaeter') {
        zeilen.push([this.t.s_values, this.t.later_summary]);
      } else if (a.methode === 'upload') {
        zeilen.push([this.t.s_values, a.datei ? this.t.s_pass + a.datei : this.t.s_uploading]);
      } else {
        zeilen.push([this.t.eye_right, this._augeText('rechts')]);
        zeilen.push([this.t.eye_left, this._augeText('links')]);
        if (a.pdEinzeln && (a.pdR || a.pdL)) {
          zeilen.push([this.t.pd, this.t.pd_right + ' ' + (a.pdR || '—') + ' mm · ' +
                                  this.t.pd_left + ' ' + (a.pdL || '—') + ' mm']);
        } else if (a.pd) {
          zeilen.push([this.t.pd, a.pd + ' mm']);
        }
      }

      return '' +
        '<div class="dm-k__zusammenfassung">' +
          zeilen.map(function (z) {
            return '<div class="dm-k__zeile"><span class="dm-k__zeile-label">' + esc(z[0]) +
                   '</span><span class="dm-k__zeile-wert">' + esc(z[1]) + '</span></div>';
          }).join('') +
        '</div>' +
        '<div class="dm-k__name">' +
          '<label class="dm-k__label" for="dm-name">' + esc(this.t.name_label) + ' <span class="dm-k__optional">' + esc(this.t.optional) + '</span></label>' +
          '<input class="dm-k__input" type="text" id="dm-name" value="' + esc(a.name) + '" placeholder="' + esc(this.t.name_ph) + '" data-dm-name>' +
          '<p class="dm-k__notiz">' + esc(this.t.name_note) + '</p>' +
        '</div>' +
        '<label class="dm-k__checkbox dm-k__checkbox--bestaetigung">' +
          '<input type="checkbox" data-dm-bestaetigt>' +
          '<span>' + esc(this.t.confirm) + '</span>' +
        '</label>';
    }

    _augeText(seite) {
      var w = this.auswahl[seite];
      if (w.sph == null) return '—';
      var t = 'Sph ' + dioptrie(w.sph);
      if (w.zyl) t += ' · Zyl ' + dioptrie(w.zyl) + ' · Achse ' + w.ach + '°';
      return t;
    }

    /* Dieselben Werte im Format der alten App — fuer die Werkstatt.
       „Beide Augen gleich" spiegelt rechts auf links, genau wie die
       deutsche Zusammenfassung und _konfigJson es tun. */
    _augeAlt(seite) {
      var a = this.auswahl;
      var w = (seite === 'links' && a.gleich) ? a.rechts : a[seite];
      if (!w || w.sph == null) return '';
      return altZahl(w.sph) + ' | ' + altZahl(w.zyl || 0) + ' | ' + altAchse(w.ach || 0);
    }

    /* Der Konfigurator erhebt eine Gesamt-PD. Die alte App notierte
       je Auge; ohne monokulare Eingabe wird haelftig geteilt. */
    _pdAlt() {
      var a = this.auswahl;
      /* Einzelwerte haben Vorrang - sie sind die genauere Angabe.
         Sonst wird die Gesamt-PD haelftig geteilt wie bisher. */
      if (a.pdEinzeln && a.pdR && a.pdL) {
        return 'OD - ' + Number(a.pdR).toFixed(2) + ' | OS - ' + Number(a.pdL).toFixed(2);
      }
      var pd = Number(a.pd);
      if (!pd) return '';
      var haelfte = (pd / 2).toFixed(2);
      return 'OD - ' + haelfte + ' | OS - ' + haelfte;
    }

    /* Die Sehwert-Properties, wie Werkstatt und Inhaber sie kennen.
       Ein Ort fuer beide Modi: Zusatzposition (items-Array) und
       Rueckfall (versteckte Formularfelder).                      */
    _rezeptFelder() {
      var a = this.auswahl;
      var t = this.t || {};
      var f = [];
      if (a.art) f.push([t.p_rezept || 'Rezepttyp', a.art.titel]);
      if (a.methode === 'spaeter') {
        f.push([t.p_werte || 'Sehwerte', t.later_summary || 'werden per E-Mail nachgereicht']);
      }
      if (a.methode === 'eingabe') {
        var od = this._augeAlt('rechts');
        var os = this._augeAlt('links');
        if (od) f.push([t.p_rechts || 'OD Right', od]);
        if (os) f.push([t.p_links || 'OS Left', os]);
        var pd = this._pdAlt();
        if (pd) f.push([t.p_pd || 'PD', pd]);
      }
      return f;
    }

    /* ---------- Werkstattzeilen ------------------------------
       Die sichtbaren Feldnamen richten sich nach der Sprache des
       Kunden. Damit die Werkstatt trotzdem immer dasselbe liest,
       gehen zwei zusaetzliche Felder mit, die nie uebersetzt
       werden. Der Unterstrich blendet sie im Warenkorb und im
       Checkout aus; im Auftrag stehen sie.

         _Werkstatt  einstaerke-ferne · vollflaeche · index-1-70
         _Werte      R -3.25 / -0.50 / x160   L ...   PD 64.00

       Grundlage sind die Handles der Metaobjekte, nicht ihre
       Titel - Handles aendern sich nicht mit der Sprache.      */

    _werkstattGlas() {
      var a = this.auswahl;
      var t = [];
      if (a.art) t.push(a.art.handle || a.art.titel);
      if (a.design) t.push(a.design.handle || a.design.titel);
      if (a.dicke) t.push(a.dicke.handle || a.dicke.titel);
      (a.extras || []).forEach(function (e) { t.push(e.handle || e.titel); });
      return t.join(' \u00B7 ');
    }

    _werkstattWerte() {
      var a = this.auswahl;
      if (a.methode === 'upload') return 'Brillenpass hochgeladen';
      if (a.methode === 'spaeter') return 'Werte werden nachgereicht';
      function auge(o) {
        if (!o) return '-';
        return altZahl(o.sph) + ' / ' + altZahl(o.zyl) + ' / ' + altAchse(o.ach);
      }
      var links = a.gleich ? a.rechts : a.links;
      var s = 'R ' + auge(a.rechts) + '   L ' + auge(links);
      if (a.pdEinzeln && a.pdR && a.pdL) {
        s += '   PD ' + Number(a.pdR).toFixed(2) + ' / ' + Number(a.pdL).toFixed(2);
      } else if (a.pd) {
        s += '   PD ' + Number(a.pd).toFixed(2);
      }
      return s;
    }

    _binde_abschluss() {
      var self = this;
      var name = this.el.body.querySelector('[data-dm-name]');
      if (name) {
        name.addEventListener('input', function () { self.auswahl.name = name.value; });
      }
      var best = this.el.body.querySelector('[data-dm-bestaetigt]');
      if (best) {
        best.addEventListener('change', function () {
          self.auswahl.bestaetigt = best.checked;
          self._weiterPruefen();
        });
      }
    }

    /* ---------- Weiter-Button freischalten ---------- */

    _weiterPruefen() {
      var schritt = this._schritte()[this.schrittIndex];
      var a = this.auswahl;
      var ok = false;

      if (schritt === 'art') ok = !!a.art;
      else if (schritt === 'design') ok = !!a.design;
      else if (schritt === 'werte') {
        if (a.methode === 'spaeter') ok = true;
        else if (a.methode === 'upload') ok = !!a.datei;
        else ok = a.rechts.sph != null && (a.gleich || a.links.sph != null);
      }
      else if (schritt === 'dicke') ok = !!a.dicke;
      else if (schritt === 'extras') ok = true;
      else if (schritt === 'abschluss') ok = !!a.bestaetigt;

      this.el.weiter.disabled = !ok;
    }

    /* ---------- Preisanzeige ---------- */

    _preisAktualisieren() {
      var a = this.auswahl;
      var summe = 0;
      /* Beim Glaeser-Produkt steckt die Verglasung schon im
         Variantenpreis - ihr Aufschlag kommt weiter unten dazu. */
      if (a.art && !this.glasImPreis) summe += Number(a.art.aufpreis) || 0;
      if (a.design) summe += Number(a.design.aufpreis) || 0;
      if (a.dicke) summe += Number(a.dicke.aufpreis) || 0;
      summe += this._extraSumme();

      /* Die Aufpreise aus den Metaobjekten stehen in Shop-Waehrung und
         werden umgerechnet. Die Glas-Differenz kommt aus Variantenpreisen
         und ist bereits in Anzeigewaehrung - sonst waere sie doppelt
         umgerechnet. */
      var zeigen = summe * kurs();
      if (a.art && this.glasImPreis) zeigen += this._glasDifferenz(a.art);

      if (zeigen > 0) {
        this.el.preis.hidden = false;
        this.el.preisWert.textContent = '+ ' + geldRoh(zeigen, this.daten.geldformat);
      } else {
        this.el.preis.hidden = true;
      }

      this._produktkopf();
    }

    /* ---------- Produkt im Drawer-Kopf -----------------------
       Zeigt jederzeit, was gerade konfiguriert wird: gewaehlte
       Variante und laufender Gesamtpreis (Maske + Verglasung +
       Aufpreise). Reine Anzeige, greift nicht in die Preislogik
       oder die Line-Item-Properties ein.                        */

    _zielVariante() {
      var aktuelle = this._aktuelleVariante() ||
        (this.daten.produkt.varianten || [])[0] || null;
      if (!this.verglasungsOption || !this.auswahl.art) return aktuelle;

      /* Neuer Modus: Die Basis bleibt None — der Verglasungspreis
         kommt als Aufpreis obendrauf, nicht aus der Variante. */
      if (this._neuerModus()) {
        return this._basisVariante() || aktuelle;
      }

      var ziel = normalisiere(this.auswahl.art.optionswert);
      var pos = this.verglasungsOption.position - 1;
      var treffer = this.daten.produkt.varianten.filter(function (v) {
        if (normalisiere(v.optionen[pos]) !== ziel) return false;
        if (!aktuelle) return true;
        return v.optionen.every(function (o, i) {
          return i === pos || normalisiere(o) === normalisiere(aktuelle.optionen[i]);
        });
      })[0];

      return treffer || aktuelle;
    }

    _produktkopf() {
      if (!this.el || (!this.el.pVariante && !this.el.pGesamt)) return;
      var v = this._zielVariante();

      if (this.el.pVariante) {
        var t = '';
        if (v && v.titel && v.titel !== 'Default Title') {
          t = v.titel;
          /* Neuer Modus: das "None" der Basis-Variante ist für den
             Kunden Rauschen — nur die übrigen Optionen (Farbe) zeigen. */
          if (this._neuerModus() && this.verglasungsOption && v.optionen) {
            var pos = this.verglasungsOption.position - 1;
            t = v.optionen.filter(function (o, i) { return i !== pos; }).join(' / ');
          }
        }
        this.el.pVariante.textContent = t;
        this.el.pVariante.hidden = !t;
      }

      if (this.el.pGesamt) {
        var a = this.auswahl;
        var summe = 0;
        /* Der Verglasungs-Aufpreis zählt nur, wenn er nicht schon im
           Variantenpreis steckt: im neuen Modus (Basis = None) und bei
           Produkten ganz ohne Verglasungs-Option. Im Altmodus trägt
           die umgeschaltete Variante den Aufpreis bereits selbst. */
        if (a.art && !this.glasImPreis &&
            (this._neuerModus() || !this.verglasungsOption)) {
          summe += Number(a.art.aufpreis) || 0;
        }
        if (a.design) summe += Number(a.design.aufpreis) || 0;
        if (a.dicke) summe += Number(a.dicke.aufpreis) || 0;
        summe += this._extraSumme();
        var basis = v ? v.preis / 100 : 0;
        this.el.pGesamt.textContent =
          geldRoh(basis + summe * kurs(), this.daten.geldformat);
      }
    }

    /* ---------- Zusatzpositionen statt Variantenwechsel ------
       Tragen die Metaobjekte eine Varianten-Referenz (varianteId),
       bleibt die Maske auf ihrer None-Variante und Verglasung wie
       Glasdicke wandern als eigene Positionen in den Warenkorb.
       Ohne varianteId gilt das Altverhalten: Variantenwechsel,
       ein einziger Kauf — die Variantenpreise im Katalog sind
       korrekt, der Rückfall ist preislich sicher.               */

    _neuerModus() {
      return !!(this.auswahl.art && this.auswahl.art.varianteId);
    }

    /* Die None-Variante zur aktuell gewählten Farbe (bzw. den
       übrigen Optionen). Ohne Verglasungs-Option am Produkt ist
       die Basis schlicht die aktuelle Variante. */
    _basisVariante() {
      /* Glaeser-Produkt: die Basis ist nicht None, sondern genau die
         Variante der gewaehlten Verglasung - sie traegt den Preis. */
      if (this.glasImPreis && this.auswahl.art) {
        var vArt = this._varianteZuArt(this.auswahl.art);
        if (vArt) return vArt;
      }

      var aktuelle = this._aktuelleVariante() ||
        (this.daten.produkt.varianten || [])[0] || null;
      if (!this.verglasungsOption) return aktuelle;

      var pos = this.verglasungsOption.position - 1;
      var basis = this.basisWert;
      var treffer = (this.daten.produkt.varianten || []).filter(function (v) {
        if (normalisiere(v.optionen[pos]) !== basis) return false;
        if (!aktuelle) return true;
        return v.optionen.every(function (o, i) {
          return i === pos || normalisiere(o) === normalisiere(aktuelle.optionen[i]);
        });
      })[0];

      return treffer || aktuelle;
    }

    /* Stellt das Kaufformular auf die None-Variante, damit die
       Variantenauflösung der Seite (Preis, Verfügbarkeit, URL)
       zur Basis passt. Gegenstück zu _variantePassend im Altmodus. */
    _varianteBasis() {
      if (!this.verglasungsOption) return;
      var basis = this._basisVariante();
      if (!basis) return;

      var select = this.form && this.form.querySelector('select[name="id"], input[name="id"]');
      if (select && String(select.value) !== String(basis.id)) {
        select.value = basis.id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /* Öffentlich: Die Sections fragen vor ihrem FormData-Submit,
       ob der Kauf über das items-Array laufen muss. */
    dmItemsBereit() {
      return !!(this.fertig && this._neuerModus());
    }

    /* Technische Rohdaten für die Werkstatt — identisch für das
       versteckte Formularfeld (Altmodus) und die Property am
       Verglasungs-Artikel (neuer Modus). */
    _konfigJson() {
      var a = this.auswahl;
      return JSON.stringify({
        art: a.art.handle,
        design: a.design ? a.design.handle : null,
        dicke: a.dicke ? a.dicke.handle : null,
        extras: a.extras.map(function (e) { return e.handle; }),
        methode: a.methode,
        rechts: a.rechts,
        links: a.gleich ? a.rechts : a.links,
        pd: a.pd,
        pdR: a.pdR,
        pdL: a.pdL,
        v: 2
      });
    }

    /* Öffentlich: legt Maske, Verglasung und ggf. Glasdicke als
       gemeinsame Gruppe in den Warenkorb. Ein Aufruf an
       /cart/add.js mit items-Array; nur der Brillenpass-Upload
       braucht einen zweiten Aufruf, weil Dateien nicht im
       JSON-Körper reisen können (multipart nur einzeln).        */
    dmItemsKauf() {
      var self = this;
      if (!this.dmItemsBereit()) return Promise.resolve(false);

      var a = this.auswahl;

      var basis = this._basisVariante();
      var basisId = basis ? basis.id : null;
      if (!basisId) {
        var select = this.form && this.form.querySelector('select[name="id"], input[name="id"]');
        if (select && select.value) basisId = Number(select.value);
      }
      if (!basisId) return Promise.resolve(false);
      if (!this.glasImPreis && !a.art.varianteId) return Promise.resolve(false);

      var menge = 1;
      if (this.form && this.form.elements && this.form.elements.quantity) {
        menge = parseInt(this.form.elements.quantity.value, 10) || 1;
      }
      if (menge < 1) menge = 1;

      var gruppe = zufallsToken();
      var maskenTitel = this.daten.produkt.titel || '';

      var tp = this.t || {};
      var nMaske = tp.p_maske || 'Maske';

      /* Die Maske trägt sichtbar, welche Verglasung dazugehört. */
      var maskeProps = { '_gruppe': gruppe };
      maskeProps[tp.p_verglasung || 'Verglasung'] = a.art.titel;

      /* Die Verglasungs-Position trägt die Sehstärken. Die Feldnamen
         erscheinen in der Sprache des Kunden, die Werkstattzeilen
         darunter immer gleich. */
      var glasProps = { '_gruppe': gruppe, '_zusatz': '1' };
      glasProps[nMaske] = maskenTitel;
      this._rezeptFelder().forEach(function (f) { glasProps[f[0]] = f[1]; });
      if (a.design) glasProps[tp.p_design || 'Glas-Design'] = a.design.titel;
      if (a.dicke) glasProps[tp.p_dicke || 'Glasdicke'] = a.dicke.titel;
      if (a.name) glasProps[tp.p_name || 'Trägername'] = a.name;
      glasProps['_Werkstatt'] = this._werkstattGlas();
      glasProps['_Werte'] = this._werkstattWerte();

      /* Glaeser-Produkt: es gibt keine zweite Position, auf der die
         Sehwerte stehen koennten - sie wandern auf die Hauptposition.
         Der Maskenname entfaellt dort, er steht schon im Titel. */
      if (this.glasImPreis) {
        Object.keys(glasProps).forEach(function (k) {
          if (k === '_gruppe' || k === '_zusatz' || k === nMaske) return;
          maskeProps[k] = glasProps[k];
        });
      }

      /* Nebenzeilen (Glasdicke, Zusatzleistungen) tragen denselben
         Maskennamen wie die Verglasungszeile. */
      function nebenProps() {
        var p = { '_gruppe': gruppe, '_zusatz': '1' };
        p[nMaske] = maskenTitel;
        return p;
      }

      var items = [
        { id: Number(basisId), quantity: menge, properties: maskeProps }
      ];

      var dickeItem = null;
      if (a.dicke && a.dicke.varianteId) {
        dickeItem = {
          id: Number(a.dicke.varianteId),
          quantity: menge,
          properties: nebenProps()
        };
      }

      var glasItem = {
        id: Number(a.art.varianteId),
        quantity: menge,
        properties: glasProps
      };

      /* Zusatzleistungen: je eine eigene Zeile, an dieselbe Gruppe
         gehaengt. Ohne hinterlegte Variante wird uebersprungen. */
      var extraItems = a.extras.filter(function (e) { return e.varianteId; })
        .map(function (e) {
          return {
            id: Number(e.varianteId),
            quantity: menge,
            properties: nebenProps()
          };
        });

      var datei = a.methode === 'upload' && this._dateiInput &&
        this._dateiInput.files && this._dateiInput.files[0]
        ? this._dateiInput.files[0]
        : null;

      var pfad = wurzelPfad() + 'cart/add.js';

      function pruefen(d) {
        if (d && d.status) throw new Error(d.description || d.message || (self.t.cart_error || 'Cart error'));
        return d;
      }

      var lauf;
      if (!datei) {
        if (!this.glasImPreis) items.push(glasItem);
        if (dickeItem) items.push(dickeItem);
        extraItems.forEach(function (it) { items.push(it); });
        lauf = fetch(pfad, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); }).then(pruefen);
      } else {
        /* Brillenpass: Dateien reisen nicht im JSON-Koerper mit.
           Deshalb erst alles uebrige per items-Array, danach die
           Position, die den Pass traegt, als multipart-Formular.
           Das ist normalerweise die Verglasung - beim Glaeser-
           Produkt die Hauptposition selbst.                       */
        var traegerItem = this.glasImPreis ? items.shift() : glasItem;
        var traegerProps = this.glasImPreis ? maskeProps : glasProps;

        if (dickeItem) items.push(dickeItem);
        extraItems.forEach(function (it) { items.push(it); });

        var vorlauf = items.length
          ? fetch(pfad, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: items })
            }).then(function (r) { return r.json(); }).then(pruefen)
          : Promise.resolve(null);

        lauf = vorlauf.then(function () {
          var fd = new FormData();
          fd.append('id', String(traegerItem.id));
          fd.append('quantity', String(menge));
          Object.keys(traegerProps).forEach(function (k) {
            fd.append('properties[' + k + ']', traegerProps[k]);
          });
          fd.append('properties[' + (tp.p_pass || 'Brillenpass') + ']', datei);
          return fetch(pfad, {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: fd
          }).then(function (r) { return r.json(); }).then(pruefen);
        });
      }

      return lauf.then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        self._warenkorbOeffnen();
        return true;
      }).catch(function (e) {
        console.warn('[dm-konfigurator] Zusatzpositionen fehlgeschlagen:', e);
        window.location.href = wurzelPfad() + 'cart';
        return false;
      });
    }

    _warenkorbOeffnen() {
      if (window.dmCart && typeof window.dmCart.open === 'function') {
        window.dmCart.open();
        return;
      }
      var knopf = document.querySelector('.js-drawer-open-cart');
      if (knopf) { knopf.click(); return; }
      window.location.href = wurzelPfad() + 'cart';
    }

    /* ---------- Abschließen: Properties schreiben ---------- */

    _abschliessen() {
      var a = this.auswahl;
      var felder = [];

      this._rezeptFelder().forEach(function (f) { felder.push(f); });
      var tf = this.t || {};
      if (a.design) felder.push([tf.p_design || 'Glas-Design', a.design.titel]);
      if (a.dicke) felder.push([tf.p_dicke || 'Glasdicke', a.dicke.titel]);
      if (a.name) felder.push([tf.p_name || 'Trägername', a.name]);
      felder.push(['_Werkstatt', this._werkstattGlas()]);
      felder.push(['_Werte', this._werkstattWerte()]);

      /* Die technischen Rohdaten (_dm_konfiguration) werden seit 2.3 nicht
         mehr mitgeschickt: _Werkstatt und _Werte tragen dieselbe Information
         lesbar, und in der Bestellansicht sah das JSON aus wie Programmcode. */

      this._felderSchreiben(felder);

      /* Neuer Modus: Die Maske bleibt auf der None-Variante, die
         Verglasung wird eigene Warenkorb-Position. Altmodus: die
         Variante wird wie bisher passend umgeschaltet.           */
      if (this._neuerModus()) {
        this._varianteBasis();
      } else {
        this._variantePassend();
      }

      this.fertig = true;
      this._kaufButtonSperren(false);
      this._zusammenfassungZeigen();
      this.el.weiter.disabled = true;
      this.schliessen();

      if (this._neuerModus()) {
        /* Ein Aufruf mit items-Array legt die ganze Gruppe in den
           Warenkorb und öffnet anschließend den Warenkorb-Drawer. */
        this.dmItemsKauf();
      } else if (this.form) {
        /* Direkt in den Warenkorb: der Submit-Handler der Produktseite
           uebernimmt (FormData inkl. form="..."-Feldern, fetch auf
           /cart/add.js) und oeffnet den Warenkorb-Drawer ueber den
           .js-drawer-open-cart-Abfang der Section dm-warenkorb. */
        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }
    }

    _felderSchreiben(felder) {
      var self = this;
      this.el.felder.innerHTML = '';
      felder.forEach(function (f) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.setAttribute('form', self.formId);
        input.name = 'properties[' + f[0] + ']';
        input.value = f[1];
        self.el.felder.appendChild(input);
      });

      /* Datei-Upload bleibt ein echtes File-Input im Formular */
      if (this.auswahl.methode === 'upload' && this._dateiInput) {
        this.el.felder.appendChild(this._dateiInput);
      }
    }

    _dateiFeld(datei) {
      if (!datei) { this._dateiInput = null; return; }
      var input = document.createElement('input');
      input.type = 'file';
      input.name = 'properties[' + ((this.t || {}).p_pass || 'Brillenpass') + ']';
      input.setAttribute('form', this.formId);
      input.className = 'dm-k__datei-versteckt';
      var dt = new DataTransfer();
      dt.items.add(datei);
      input.files = dt.files;
      this._dateiInput = input;
    }

    /* ---------- Variante mitschalten -------------------------
       Nur wenn das Produkt eine Verglasungs-Option hat. Sonst
       läuft der Konfigurator rein über Properties und lässt die
       Variantenlogik des Themes unangetastet.                   */

    _variantePassend() {
      if (!this.verglasungsOption || !this.auswahl.art) return;

      var ziel = normalisiere(this.auswahl.art.optionswert);
      var pos = this.verglasungsOption.position - 1;
      var aktuelle = this._aktuelleVariante();

      var treffer = this.daten.produkt.varianten.filter(function (v) {
        if (normalisiere(v.optionen[pos]) !== ziel) return false;
        if (!aktuelle) return true;
        // andere Optionen beibehalten
        return v.optionen.every(function (o, i) {
          return i === pos || normalisiere(o) === normalisiere(aktuelle.optionen[i]);
        });
      })[0];

      if (!treffer) return;

      var select = this.form && this.form.querySelector('select[name="id"], input[name="id"]');
      if (select && String(select.value) !== String(treffer.id)) {
        select.value = treffer.id;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    _aktuelleVariante() {
      var select = this.form && this.form.querySelector('select[name="id"], input[name="id"]');
      if (!select || !select.value) return null;
      var id = String(select.value);
      return this.daten.produkt.varianten.filter(function (v) {
        return String(v.id) === id;
      })[0] || null;
    }

    _varianteGeaendert(variant) {
      if (!this.auswahl.art) return;

      /* Glaeser-Produkt: die Variante selbst traegt die Verglasung -
         verglichen wird die ID, nicht der uebersetzte Optionswert. */
      if (this.glasImPreis) {
        var soll = this._varianteZuArt(this.auswahl.art);
        if (soll && variant && variant.id &&
            String(variant.id) !== String(soll.id)) {
          this._zuruecksetzen();
        }
        return;
      }

      if (!this.verglasungsOption) return;
      var pos = this.verglasungsOption.position - 1;
      var wert = normalisiere(variant.options ? variant.options[pos] : '');
      /* Im neuen Modus bleibt die Maske absichtlich auf None —
         erwartet ist dann "none", nicht der gewählte Optionswert. */
      var erwartet = this._neuerModus()
        ? this.basisWert
        : normalisiere(this.auswahl.art.optionswert);
      if (wert && wert !== erwartet) {
        /* Der Kunde hat die Verglasung über die Variantenauswahl
           umgestellt — Konfiguration verwerfen, damit nichts
           Widersprüchliches im Warenkorb landet. */
        this._zuruecksetzen();
      }
    }

    _zuruecksetzen() {
      this.auswahl.art = null;
      this.auswahl.design = null;
      this.auswahl.dicke = null;
      this.auswahl.extras = [];
      this.auswahl.bestaetigt = false;
      this.schrittIndex = 0;
      this.fertig = false;
      this.el.felder.innerHTML = '';
      this.el.summary.textContent = this.t.trigger_sub || '';
      this.el.trigger.classList.remove('is-fertig');
      this._kaufButtonSperren(true);
      this._produktkopf();
    }

    /* ---------- Zusammenfassung am Auslöser ---------- */

    _zusammenfassungZeigen() {
      var a = this.auswahl;
      var teile = [a.art.titel];
      if (a.dicke) teile.push(a.dicke.titel);
      if (a.methode === 'eingabe' && a.rechts.sph != null) {
        teile.push('R ' + dioptrie(a.rechts.sph) + ' · L ' + dioptrie(a.gleich ? a.rechts.sph : a.links.sph));
      }
      this.el.summary.textContent = teile.join(' · ');
      this.el.trigger.classList.add('is-fertig');
      this.el.hinweis.hidden = true;
    }

    _hinweisZeigen() {
      this.el.hinweis.hidden = false;
      this.el.trigger.classList.add('is-fehler');
      var self = this;
      setTimeout(function () { self.el.trigger.classList.remove('is-fehler'); }, 1200);
    }

    /* ---------- Kaufbutton sperren --------------------------
       Nur optisch und über den submit-Abfangjäger. Der Button
       selbst wird nicht disabled, damit Symmetrys eigenes
       Zustandsmanagement nicht durcheinandergerät.              */

    _kaufButtonSperren(sperren) {
      if (!this.form) return;
      this.form.classList.toggle('dm-k-unvollstaendig', !!sperren);
    }
  }

  if (!customElements.get('dm-konfigurator')) {
    customElements.define('dm-konfigurator', DmKonfigurator);
  }
})();

